export const PAGE_TITLE = "IIH Training";

export const PAGE_INTRO_TEXT =
  "Welcome to the Institute of Interpersonal Hypnotherapy's Learning Management System! Here, current and prospective students can access their enrolled training levels. The available access levels include:";

export const LEARN_MORE_TEXT = "Learn More";

export const FOOTER_TEXT =
  "We're excited to support your journey in becoming a skilled hypnotherapy professional!";

export const TRAINING_LEVEL_DATA = [
  {
    id: 1,
    title: "IIH Learning Management System",
    text: "Click here for current students, graduates, and CEU courses.",
    link: "https://student.instituteofhypnotherapy.com/login",
    size: 6,
  },
  {
    id: 2,
    title: "Diving Deeper",
    text: "Reserve your seat for the next start date with a $300 deposit, granting access to the first 20 hours of training.",
    link: "https://instituteofhypnotherapy.com/enrollment-consult1/",
  },
  {
    id: 3,
    title: "Our first 300-hour state-licensed Hypnotherapy Training program",
    hasTooltip: true,
    text: "Final 100 hours to complete the Certified Hypnotherapist Training Program (Hours 201–300 of 300).",
    link: "https://www.instituteofhypnotherapy.com/course/certified-hypnotherapist/",
  },
  {
    id: 4,
    title: "Clinical Hypnotherapist",
    text: "100 additional hours beyond the Certified Hypnotherapist Training Program, totaling 400 hours of training.",
    link: "https://www.instituteofhypnotherapy.com/course/clinical-hypnotherapist/",
  },
  {
    id: 5,
    title: "Transpersonal Hypnotherapist",
    text: "100 hours beyond the Certified Hypnotherapist and Clinical Hypnotherapist Training programs, for a total of 500 training hours.",
    link: "https://www.instituteofhypnotherapy.com/course/transpersonal-hypnotherapist/",
  },
  {
    id: 6,
    title: "Interpersonal Hypnotherapist",
    text: "An extra 22 hours beyond the core 500-hour training programs, for a comprehensive total of 522 training hours.",
    link: "https://www.instituteofhypnotherapy.com/ceu/interpersonal-hypnotherapist-certification-course/",
  },
];
